/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import PrettyPrintJson from 'components/pretty-print-json';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';

/**
 * Style dependencies
 */
import './styles.scss';
import { requestResource } from 'state/resources/actions';
import { getResourceId } from 'state/ui/resource-info-modal/selectors';

const ResourceInfoModal = ({ resourceId, isVisible, onClosed, close, ...props }) => {
   
    const [requesting, setRequesting] = useState(true);
    const [resource, setResource] = useState(null);

    useEffect(() => {
        if (resourceId && isVisible) {
            setRequesting(true);
            setResource(null);
            loadData(resourceId);
        }
    }, [resourceId, isVisible]);

    const loadData = async (resourceId) => {
        try {
            setRequesting(true);
            let result = await props.requestResource(resourceId);
            setResource(result);
            setRequesting(false);
        } catch (error) {
            close();
        }
    };

    if (!isVisible || !resourceId) {
        return null;
    }

    return (
        <Modal title='Resource JSON Data' isVisible={isVisible} close={close} onClosed={onClosed}>
            <Box padding='large'>{resource && <PrettyPrintJson data={resource.data} />}</Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        resourceId: getResourceId(state),
        isVisible: isModalVisible('ResourceInfoModal')(state),
    }),
    {
        requestResource,
        close: createCloseModalAction('ResourceInfoModal'),
    },
)(ResourceInfoModal);
